 export const onChangeLabelSymbol = (layer,field,size,outlineColor,color,labelPlacement="above-right") => {
    const labelClass = {
      // autocasts as new LabelClass()
      symbol: {
        type: "text", // autocasts as new TextSymbol()
        color: color,
        haloColor:outlineColor,
        haloSize: 1,
        font: {
          // autocast as new Font()
          family: "Ubuntu Mono",
          size: size,
          weight: "bold",
        },
      },
      labelPlacement: labelPlacement,
      labelExpressionInfo: {
        expression: "$feature." + field,
      },
      // maxScale: 0,
      // minScale: 25000000,
      //where: "Conference = 'AFC'"
    };
    layer.labelingInfo = [labelClass];
  };
  
  export const onChangeLabelEnabled = (e: any, layer, callback) => {
    layer.labelsVisible = e.target.checked;
    callback(e.target.checked);
  };

export const PointLabelPlacementArray=["above-center","above-left","above-right","below-center","below-left","below-right",
"center-center","center-left", "center-right"]

// export const PolyLineLabelPlacementArray=["above-after","above-along", "above-before", "above-start", "above-end",
// "below-after", "below-along", "below-before", "below-start", "below-end", "center-after", "center-along","center-before",
// "center-start","center-end"]